/* AM Bestsellers Grid - fundido escalonado de las imagenes al entrar en pantalla.
   Replica el efecto AOS del tema de la competencia (olivianewyork / serenafirenze):
   la imagen pasa de opacity 0 a 1 en 1s cubic-bezier(.26,.54,.32,1), con retardo
   por posicion en la fila. El retardo lo pone el CSS de la seccion.

   Va en un ASSET EXTERNO a proposito: en este tema un <script> inline dentro de una
   seccion pierde sus listeners cuando algo re-renderiza el DOM.

   SEGURIDAD: las imagenes solo se ocultan si este script llega a marcar la seccion con
   data-anim="1". Si el asset no carga, no se oculta nada y la seccion se ve normal. */
(function () {
  var SEC = '[data-am-bsg]';

  function reveal(card) {
    if (card && !card.classList.contains('is-in')) card.classList.add('is-in');
  }

  function revealAll(cards) {
    for (var i = 0; i < cards.length; i++) reveal(cards[i]);
  }

  function initSection(sec) {
    if (sec.__ambsgAnim) return;
    sec.__ambsgAnim = 1;

    var cards = [].slice.call(sec.querySelectorAll('.am-bsg__card'));
    if (!cards.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var noIO = !('IntersectionObserver' in window);

    /* Sin animacion si el usuario la rechaza, si el navegador no la soporta, o si la
       pestana esta oculta (con visibilityState hidden no corre IntersectionObserver:
       sin esto las imagenes se quedarian invisibles para siempre). */
    if (reduce || noIO || document.hidden) {
      revealAll(cards);
      return;
    }

    sec.setAttribute('data-anim', '1');

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          reveal(entries[i].target);
          io.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    for (var i = 0; i < cards.length; i++) io.observe(cards[i]);

    /* Red de seguridad: si en 2,5s alguna tarjeta ya esta en pantalla y sigue sin
       revelarse (el observer no disparo), revelarla a mano. */
    setTimeout(function () {
      for (var j = 0; j < cards.length; j++) {
        var r = cards[j].getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) reveal(cards[j]);
      }
    }, 2500);

    /* Si la pestana vuelve a ser visible, asegurar que nada quedo invisible. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        setTimeout(function () {
          for (var k = 0; k < cards.length; k++) {
            var r2 = cards[k].getBoundingClientRect();
            if (r2.top < window.innerHeight && r2.bottom > 0) reveal(cards[k]);
          }
        }, 300);
      }
    });
  }

  function scan() {
    var secs = document.querySelectorAll(SEC);
    for (var i = 0; i < secs.length; i++) {
      var s = secs[i];
      /* Un clon conserva los atributos pero no las propiedades: si esta marcado pero
         no tiene la propiedad, es un clon -> reinicializar. */
      if (s.getAttribute('data-anim') === '1' && !s.__ambsgAnim) s.removeAttribute('data-anim');
      initSection(s);
    }
  }

  var t = null;
  function scanDebounced() {
    if (t) clearTimeout(t);
    t = setTimeout(scan, 120);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scanDebounced);
  document.addEventListener('shopify:section:load', scanDebounced);

  if (window.MutationObserver) {
    new MutationObserver(scanDebounced).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
